import {
  faBackward,
  faBackwardStep,
  faCog,
  faForward,
  faForwardStep,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { changePosition } from "../../canvasUtils";
import { ANIMATIONS } from "../../constants/general";
import { CanvasContext } from "./CanvasContext";
import TextTools from "./TextTools";

const notIncludeTransition = ["avatar", "background", "backgroundVideos"];

const ContextMenu = ({
  show,
  type,
  position,
  onClose,
  onAnimationSelect,
  selectedAnimation,
  onFontSettings,
  onTrash,
  applyFont,
  applyColor,
}) => {
  // Hide the menu if the user clicks anywhere outside of it
  const [fontMenu, setFontMenu] = useState(!show);
  const { slides, currentSlideIndex } = useSelector((state) => state.slides);
  const { canvas } = useContext(CanvasContext);
  const dispatch = useDispatch();

  if (!show) {
    if (fontMenu) setFontMenu(false);
    return null;
  }

  const style = {
    display: "block",
    position: "absolute",
    top: `${position.y}px`,
    left: `${position.x}px`,
    zIndex: 1000,
  };

  const handlePosition = (action) => {
    return changePosition(canvas, action, dispatch, slides[currentSlideIndex]);
  };

  return fontMenu === false ? (
    <div
      id="contextMenu"
      className="w-36 context-menu p-4 py-2 text-sm bg-gray-200 rounded-lg shadow-lg"
      style={style}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="space-y-2">
        {!notIncludeTransition.includes(type) && (
          <div className="">
            <div className="text-xs border-b border-gray-500 font-bold mb-2 text-gray-500">
              Animate
            </div>
            <div className="w-full flex justify-center items-center">
              <div className="grid grid-cols-3 gap-1">
                {Object.entries(ANIMATIONS).map(([key, value]) => (
                  <div className="w-10 h-10">
                    <img
                      className={`rounded-lg hover:shadow-lg hover:cursor-pointer hover:border hover:bg-gray-500 hover:bg-white border-gray-400  
                      ${selectedAnimation === value ? "bg-white" : ""}`}
                      src={
                        "/tool/dashboard/static/images/icons/tools/" + value + ".svg"
                      }
                      alt={value}
                      title={value}
                      onClick={() => onAnimationSelect(value)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {type === "text" && (
          <div
            className="text-xs hover:cursor-pointer hover:bg-white p-1 rounded-lg"
            onClick={(e) => {
              setFontMenu(true);
              e.stopPropagation();
            }}
          >
            <FontAwesomeIcon className="text-gray-500 mr-2 " icon={faCog} />
            Font settings
          </div>
        )}
        {(type !== "background" || type !== "backgroundVideos") && (
          <>
            <div
              className="text-xs hover:cursor-pointer hover:bg-white p-1 rounded-lg"
              onClick={(e) => {
                handlePosition("sendBackward");
                e.stopPropagation();
              }}
            >
              <FontAwesomeIcon
                className="text-gray-500 mr-2 "
                icon={faBackwardStep}
              />
              Send to backward
            </div>
            <div
              className="text-xs hover:cursor-pointer hover:bg-white p-1 rounded-lg"
              onClick={(e) => {
                handlePosition("sendToBack");
                e.stopPropagation();
              }}
            >
              <FontAwesomeIcon
                className="text-gray-500 mr-2 "
                icon={faBackward}
              />
              Send to back
            </div>

            <div
              className="text-xs whitespace-nowrap hover:cursor-pointer hover:bg-white p-1 rounded-lg"
              onClick={(e) => {
                handlePosition("bringForward");
                e.stopPropagation();
              }}
            >
              <FontAwesomeIcon
                className="text-gray-500 mr-2 "
                icon={faForwardStep}
              />
              Send to Forward
            </div>

            <div
              className="text-xs hover:cursor-pointer hover:bg-white p-1 rounded-lg"
              onClick={(e) => {
                handlePosition("bringToFront");
                e.stopPropagation();
              }}
            >
              <FontAwesomeIcon
                className="text-gray-500 mr-2 "
                icon={faForward}
              />
              Send to front
            </div>
          </>
        )}
        {type === "graphics" && (
          <div
            className="text-xs hover:cursor-pointer hover:bg-white p-1 rounded-lg"
            onClick={(e) => {
              setFontMenu(true);
              e.stopPropagation();
            }}
          >
            <FontAwesomeIcon className="text-gray-500 mr-1  " icon={faCog} />
            Asset Settings
          </div>
        )}

        {type !== "avatar" && (
          <div
            className="text-xs hover:cursor-pointer hover:bg-white p-1 rounded-lg"
            onClick={onTrash}
          >
            <FontAwesomeIcon className="text-gray-500 mr-2" icon={faTrash} />
            Trash
          </div>
        )}
      </div>
    </div>
  ) : (
    <TextTools
      position={position}
      show={show}
      applyFont={applyFont}
      applyColor={applyColor}
      type={type}
    />
  );
};

export default ContextMenu;
